
import { Component, Vue } from "vue-property-decorator";
import { RouteMeta } from "vue-router/types/router";
import Answer from "@/components/QA/Answer.vue";
import Breadcrumb from "@/components/Utility/Breadcrumb.vue";
import { QaItem } from "@/models/QaAnswer";

declare type breadcrumb = { name?: string; link?: string; onClick?: () => void };

@Component({
  components: { Answer, Breadcrumb },
})
export default class Order extends Vue {
  orderList: QaItem[] = [
    {
      QTwo: "我一定要透過APP下單嗎？",
      Ans: [
        "是，除了透過師虎來了APP下單，個人用戶不接受任何形式包含電話、FB等等，為了確保您在體驗師虎修繕服務，全程都可以擁有一對一客服專案管理師為您掌管專案進度。",
      ],
    },
    {
      QTwo: "只能用信用卡付款嗎？",
      Ans: [
        "新台幣五萬元以下小額修繕我們只提供線上刷卡，若超過新台幣五萬我們會開放權限給您，可選擇採用匯款或信用卡支付方式。",
      ],
    },
    {
      QTwo: "我可以事先客製估價嗎？",
      Ans: [
        "平台在每一個工項都有提供一個過去累積該項目最常發生的金額給您參考，你可以事先查看，但無法在立案前為您專屬報價，實際報價仍要以師傅至現場勘查後為依據。",
      ],
    },
    {
      QTwo: "為何要支付派遣費？",
      Ans: [
        "每一位師傅至您府上勘查至少要花費1-2小時，包含通勤時間，油資，人力成本，專業技術以及平台的維運，若您不同意師傅報價，我們仍然會支付師傅車馬費用，讓他獲得應該有的報酬。",
      ],
    },
    {
      QTwo: "派遣費可以折抵施工費用嗎？",
      Ans: [
        "可以，當您同意師傅報價單，此筆派遣費是可以全額抵扣，但加成時段收取的派遣費，若施工費用低於加成金額，仍以加成金額計算，不會退還差額。",
      ],
    },
    {
      QTwo: "派遣費可以退嗎？",
      Ans: [
        "不行，我們是在媒合師傅成功後才會收取派遣費，代表您已經預約師傅的時間。但您最多可保留一個月時間，安排好時間後再重新預約下單。",
      ],
    },
    {
      QTwo: "派遣費是多少？任何時段都一樣嗎？",
      Ans: [
        "派遣費並非固定金額，會依您叫修的時段而不同，最低為 $300。",
        "派遣費依叫修時段分為五種：",
        {
          list: "ul",
          items: [
            "**一般時段**：週一至週五 AM8:00–PM5:59（不含國定假日、連續假日），**$300**",
            "**夜間加成**：週一至週五 PM6:00–PM8:59，**$2,500**",
            "**假日加成**：週六、週日 AM8:00–PM8:59，**$2,500**",
            "**國定假日／連續假日加成**：AM8:00–PM8:59，**$3,500**",
            "**特殊時段加成**：以上時段以外（如深夜、清晨），**$4,500**",
          ],
        },
        "若非緊急狀況，建議選擇一般時段叫修，可省下加成費用。《師虎Pro》會員的每年6次免派遣費優惠，也僅適用於一般時段，不適用加成時段。",
      ],
    },
    {
      QTwo: "平台會開立發票嗎？",
      Ans: ["會。"],
    },
    {
      QTwo: "如有報帳需求，可以開立統一編號嗎？",
      Ans: ["可以，當您在下單前填寫訂單資訊頁面可以輸入統一編號。"],
    },
    {
      QTwo: "平台流程哪裡可以看到？",
      Ans: ["從下單流程可以看到。"],
    },
    {
      QTwo: "我可以先連絡客服嗎？",
      Ans: [
        "在您成立訂單後，即可透過聊天室與一對一客服專案管理師聯繫。",
      ],
    },
  ];
  questionObj?: QaItem;
  // viewWidth!: number;
  isAnswer = false;

  //hook
  // mounted(): void {
  //   this.viewWidth = window.innerWidth;
  //   window.onresize = () => {
  //     this.viewWidth = window.innerWidth;
  //   };
  // }
  //computed
  get breadcrumbItems(): breadcrumb[] | null {
    if (!this.isAnswer || !this.questionObj) return null;
    const meta = (this.$route.meta as RouteMeta).breadcrumb as breadcrumb[];
    const [parent, current] = meta;
    return [
      parent,
      { name: current.name, onClick: () => { this.isAnswer = false; } },
      { name: this.questionObj.QTwo },
    ];
  }

  //methods
  getQuestion(questionItem: QaItem): void {
    // let index = e.target.getAttribute("index");
    // this.questionObj = this.orderList[index];
    this.questionObj = questionItem;

    this.isAnswer = true;

    if(window.innerWidth > 768){
        window.scroll({
          top: 300,
        });
    }

    // if (this.viewWidth > 768) {
    //   document.documentElement.scrollTop = 300;
    // } else {
    //   document.documentElement.scrollTop = 0;
    // }
  }

  handleBack(): void {
    if (this.isAnswer) {
      this.isAnswer = false;
    } else {
      this.$router.push("/QA");
    }
  }
}
